<ion-header>
  <ion-toolbar>
    <div *ngIf="hasPublicContext; else detailsOnly" slot="start" class="tab-buttons">
      <ion-button (click)="selectActionsLog()" [class.selected]="!isPublicContextSelected" fill="clear">
        {{ 'm/task-process/task-actions-title' | translate }}
      </ion-button>
      <ion-button (click)="selectPublicContext()" [class.selected]="isPublicContextSelected" fill="clear">
        {{ 'm/task-process/public-context/modal-title' | translate }}
      </ion-button>
    </div>
    <ng-template #detailsOnly>
      <div slot="start" class="details-only-title">
        {{ 'm/task-process/task-actions-title' | translate }}
      </div>
    </ng-template>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-button">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- details tab  -->
<app-task-actions-log
  *ngIf="hasActionsLogBeenSelectedAtLeastOnce"
  [hidden]="isPublicContextSelected"
  [taskProcessContext]="taskProcessContext"
  [task]="task"></app-task-actions-log>

<!-- public context tab -->
<app-public-context
  *ngIf="hasPublicContextBeenSelectedAtLeastOnce"
  [hidden]="!isPublicContextSelected"
  [taskProcessContext]="taskProcessContext"
  [task]="task"></app-public-context>
